import { FourierFilm } from "./FourierHeart";
import { DinosaurArtwork } from "./DinosaurArtwork";
import { dinosaurModel } from "./dinosaurModel";
import { dinosaurTheme, DINOSAUR_TRACE_WIDTH } from "./dinosaurTheme";

export const FourierDinosaur = () => (
  <FourierFilm
    model={dinosaurModel}
    targetLabel="TRACED T-REX"
    centerFinal
    colors={dinosaurTheme.colors}
    timing={dinosaurTheme.timing}
    skipIntroCopy
    flatStyle
    traceWidth={DINOSAUR_TRACE_WIDTH}
    finalArtwork={<DinosaurArtwork />}
    artworkReveal={{ delay: 0.3, duration: 0.45 }}
    outroText={["THIS IS", "FOURIER T-REX"]}
  />
);
